module.exports = __webpack_public_path__ + "img/Honduras.b2b088b9.svg";